<template>
<div class="chapter">
<div class="inner_page">
<h1>New lands</h1>
<h2 class="sigil_not_in_toc">Within the Arctic circle</h2>
<h2 class="sigil_not_in_toc">Julius Payer</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?48bbc43d